import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router';
import AuthLayout from './layouts/auth-layout';
import UnauthLayout from './layouts/unauth-layout';
import {
  AuthenticationHistory, ChangePassowrd, GlobalMccBlock, ApiConfigList, Dashboard, Home,
  Login, MCCBlockManagementInbox, Otp, ParticipantManagementInbox, ParticipantMccBlock,
  Participants, Roles, RuleEngine, RuleEngineManagementInbox, UserManagementInbox, Users,
  ApiConfigManagementInbox, RoleManagementInbox, GlobalCountryBlock, ParticipantCountryBlock,
  CountryBlockManagementInbox, ReportCatalog,
  CardStatusManagement,
  CardStatusFileImportLogs,
  CardStatusFileImportAuditLogs
} from './pages';
import { useDispatch, useSelector } from 'react-redux';
import AutoLogout from './helpers/autoLogout';
import { getRolesList } from './redux/slices/roles-list-slice';
import { getInstitutionsList } from './redux/slices/institutions-list-slice';
import { getSchemesList } from './redux/slices/schemes-list-slice';
import { NotFound404 } from './components';
import { getAllAvailableCountryCodeList } from './redux/slices/global-country-code-block-slice';
import { getCountryList } from './redux/slices/participants-slice';
// import { getApiConfigValues } from './redux/slices/api-config-slice';
import './App.css';
import { MenuMainConstants } from './constants/menus-constant';
import { ReportJobsStatusConstant } from './pages/report-catalog/report-catalog.constants';

function App() {
  const dispatch = useDispatch();
  const { isAuthenticated, user } = useSelector((state) => state.loginUserReducer);
  const { isLoading: isGlobalApiLoading } = useSelector((state) => state.globalLoadingReducer);
  const { jobs: reportJobs } = useSelector((state) => state.ReportCatalogReducer);

  useEffect(() => {
    const fetchData = async () => {
      if (user && isAuthenticated) {
        try {
          const promises = [
            dispatch(getRolesList(user)),
            dispatch(getInstitutionsList(user)),
            dispatch(getSchemesList(user)),
            dispatch(getCountryList(user)),
            // dispatch(getApiConfigValues(user)),
            // dispatch(getAllAvailableMccsList({ user , search: { institutionCode: null } })),
          ];

          if (user?.permissions?.find(permission => permission.pageUrl === MenuMainConstants?.countryBlockParent)) {
            promises.push(
              dispatch(getAllAvailableCountryCodeList({ user, search: { institutionCode: null } }))
            );
          }

          await Promise.all(promises);
        } catch (error) {
          console.error("Error fetching roles or institutions list:", error);
        }
      }
    };

    fetchData();
  }, [user, dispatch, isAuthenticated]);


  return (
    <main className='app'>
      <Routes>
        {/* ROOT */}
        <Route
          path="/"
          element={isAuthenticated ? <Navigate to="/app" /> : <Navigate to="/login" />}
        />

        {/* ROUTES FOR UNAUTHENTICATION USERS */}
        <Route element={<UnauthLayout />}>
          <Route path="/login" element={<Login />} />
          <Route path="/otp" element={<Otp />} />
          <Route path='*' element={<NotFound404 label='404' text='OOPS! PAGE NOT FOUND' showButton buttonLabel='Go back' buttonPath='/login' />} />
        </Route>

        {/* ROUTES FOR AUTHENTICATION USERS */}
        <Route element={<AuthLayout />}>
          <Route path="/app" element={<Navigate to="/app/home" />} />
          <Route path="/app/home" element={<Home />} />

          <Route path="/app/dashboard" element={<Navigate to="/app/dashboard/home" />} />
          <Route path="/app/dashboard/home" element={<Dashboard />} />

          <Route path="/app/role-management" element={<Navigate to="/app/role-management/role-view" />} />
          <Route path="/app/role-management/role-view" element={<Roles />} />
          <Route path="/app/role-management/maker-inbox" element={<RoleManagementInbox />} />
          <Route path="/app/role-management/checker-inbox" element={<RoleManagementInbox />} />

          <Route path="/app/user-management" element={<Navigate to="/app/user-management/user" />} />
          <Route path="/app/user-management/user" element={<Users />} />
          <Route path="/app/user-management/maker-inbox" element={<UserManagementInbox />} />
          <Route path="/app/user-management/checker-inbox" element={<UserManagementInbox />} />

          <Route path="/app/participant-management" element={<Navigate to="/app/participant-management/viewparticipant" />} />
          <Route path="/app/participant-management/viewparticipant" element={<Participants />} />
          <Route path="/app/participant-management/maker-inbox" element={<ParticipantManagementInbox />} />
          <Route path="/app/participant-management/checker-inbox" element={<ParticipantManagementInbox />} />

          <Route path="/app/mcc-block-management" element={<Navigate to="/app/mcc-block-management/globalview" />} />
          <Route path="/app/mcc-block-management/globalview" element={<GlobalMccBlock />} />
          <Route path="/app/mcc-block-management/participantview" element={<ParticipantMccBlock />} />
          <Route path="/app/mcc-block-management/maker-inbox" element={<MCCBlockManagementInbox />} />
          <Route path="/app/mcc-block-management/checker-inbox" element={<MCCBlockManagementInbox />} />

          <Route path="/app/country-block-management" element={<Navigate to="/app/country-block-management/globalview" />} />
          <Route path="/app/country-block-management/globalview" element={<GlobalCountryBlock />} />
          <Route path="/app/country-block-management/participantview" element={<ParticipantCountryBlock />} />
          <Route path="/app/country-block-management/maker-inbox" element={<CountryBlockManagementInbox />} />
          <Route path="/app/country-block-management/checker-inbox" element={<CountryBlockManagementInbox />} />

          <Route path="/app/api-configuration-management" element={<Navigate to="/app/api-configuration-management/apiconfigurationview" />} />
          <Route path="/app/api-configuration-management/apiconfigurationview" element={<ApiConfigList />} />
          <Route path="/app/api-configuration-management/maker-inbox" element={<ApiConfigManagementInbox />} />
          <Route path="/app/api-configuration-management/checker-inbox" element={<ApiConfigManagementInbox />} />

          <Route path="/app/rule-management" element={<Navigate to="/app/rule-management/viewrule" />} />
          <Route path="/app/rule-management/viewrule" element={<RuleEngine />} />
          <Route path="/app/rule-management/maker-inbox" element={<RuleEngineManagementInbox />} />
          <Route path="/app/rule-management/checker-inbox" element={<RuleEngineManagementInbox />} />

          {/* <Route path="/app/acs-params-management" element={<Navigate to="/app/acs-params-management/viewacsparams" />} />
          <Route path="/app/acs-params-management/viewacsparams" element={<AcsParameters />} />
          <Route path="/app/acs-params-management/maker-inbox" element={<AcsParameterInbox />} />
          <Route path="/app/acs-params-management/checker-inbox" element={<AcsParameterInbox />} /> */}

          <Route path="/app/authentication-history" element={<Navigate to="/app/authentication-history/viewauthenticationhistory" />} />
          <Route path="/app/authentication-history/viewauthenticationhistory" element={<AuthenticationHistory />} />

          <Route path="/app/report-catalog" element={<Navigate to="/app/report-catalog/view-reports" />} />
          <Route path="/app/report-catalog/view-reports" element={<ReportCatalog />} />

          {/* <Route path="/app/audit-log" element={<Navigate to="/app/audit-log/viewlogs" />} />
          <Route path="/app/audit-log/viewlogs" element={<AuditLogs />} /> */}

          <Route path="/user-operations" element={<Navigate to="/user-operations/changepassword" />} />
          <Route path="/user-operations/changepassword" element={<ChangePassowrd />} />

          <Route path="/app/card-status-management" element={<Navigate to="/app/card-status-management/view-list" />} />
          <Route path="/app/card-status-management/card-registry" element={<CardStatusManagement />} />
          <Route path="/app/card-status-management/file-import-logs" element={<CardStatusFileImportLogs />} />
          <Route path="/app/card-status-management/audit-and-reports" element={<CardStatusFileImportAuditLogs />} />
        </Route>
      </Routes>

      {/* AUTO LOGOUT AFTER SESSION END */}
      {
        !isGlobalApiLoading && !(reportJobs?.some(job => job.status === ReportJobsStatusConstant?.progress)) &&
        <AutoLogout />
      }
    </main>
  );
}

export default App;
